<!--
================================================
CurrentTaskComp

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/timeTracking

Description : Permet visualiser/stopper une tâche en cours

    * Lorsqu'un task timerecord est continué depuis TaskTimerecordTableLineComp, le listener 'stop_current_task' stoppe le current task timerecord depuis ici.


================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="CurrentTaskComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
<!--        {{'Hello ! :) I am ' + $options.name}}-->

        <div class="columns">
            <div class="column">

                <div class="appTitle">
<!--                    <font-awesome-icon :icon="['fas', 'bookmark']" />-->
                    {{$t('MonPointageActuel')}}
                </div>

                <div class="appBloc fieldBox">

                    <div class=" currentTask">

                        <span class=" name" v-on:click="openModalTrEdit(currentTaskTr)" v-bind:title="$t('modifierLePointage')">
                            <font-awesome-icon :icon="['far', 'bookmark']" class="icon mr-2" />

                          <span v-if="currentTaskTr.taskName !=null">{{currentTaskTr.taskName}}</span>
                          <span v-else class="has-text-grey-light">{{$t('(sansDescription)')}}</span>
                        </span>

                        <span v-bind:title="$t('projet')" class="project" v-if="currentTaskTr.project !== null">
                                <font-awesome-icon v-bind:style="{color:'#'+ currentTaskTr.project.color}" class="icon mr-1" :icon="['far', 'folder-open']"/>
                                <span class="projectName" v-bind:style="{color:'#'+ currentTaskTr.project.color}">{{currentTaskTr.project.name}}</span>
                        </span>

                        <span v-bind:title="$t('client')" class="client"
                              v-if="currentTaskTr.project !== null && currentTaskTr.project.client !== null">
                                <font-awesome-icon :icon="['fas', 'user-tie']" class="icon mr-1"/>
                                <span class="">{{currentTaskTr.project.client.name}}</span>
                        </span>


                      <!-- affichage des tags  -->
                      <span class="tagZone pl-2 ml-3" v-if="currentTaskTr.tags.length> 0"
                            :content="$tc('xTags',currentTaskTr.tags.length) + ' : '+ displayTagsInline(currentTaskTr,0)"
                            v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger: 'mouseenter'}"
                      >
                        <span  class="has-text-grey-light tagCount " v-bind:title="$tc('xTags',currentTaskTr.tags.length)">
                        <!-- si un tag au moins est sélectionné affichage du nombre de tags sélectionnés -->
                            <font-awesome-icon  class="icon " :icon="['fas', 'tag']"/>
                           {{$tc('xTags',currentTaskTr.tags.length)}}
                        </span>
                      </span>

                        <span v-bind:title="$t('facturable')" class="isBillable"
                              v-if="currentTaskTr.isBillable ==true" >
                            <span class="circle">
                              <font-awesome-icon class="icon" :icon="['fas', 'dollar-sign']"/>
                            </span>
                            {{$t('facturable')}}
                        </span>

                        <div class="duration columns is-gapless">
                            <div class="column is-1">
                                <a id="currentTaskStopBtn" class="stopBtn" v-on:click="sendStopQuery()" v-bind:title="$t('stopperLePointageEncours')">
                                    <font-awesome-icon class="icon" :icon="['fas', 'stop']" />

                                </a>
                            </div>
                            <div class="column">
                                <span id="taskTimerValue">{{timerDisplayValue}}</span>

                            </div>
                        </div>

                    </div>
                </div>



            </div>
        </div>


    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TagComp from "@/components/Tags/TagComp";
    import TagMixin from "@/mixins/TagMixin";
    import TrackingMixin from "@/mixins/TrackingMixin";
    // import _ from 'lodash'

    export default {
        name: 'CurrentTaskComp',
      components: {TagComp},
 //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TagMixin, TrackingMixin],

        data: function () {
            return {
                locale : this.$route.params.locale,
                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization,
                userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
                // =================================================================
                isSubmiting: false ,     // indique si le formulaire est en cours de soumission

                taskName: null, // le nom de la tâche
                timer: null,    // un objet easyTimer.js
                timerStartValues: {hours: null, minutes: null, seconds: null}, // les valeurs de départ pour démarrer le timer
                timerDisplayValue: '', // la valeur du timer
                intervals: //  des intervals retournés par SetInterval (On lé créé ici pour pouvoir les supprimer via clerInterval()
                    {
                        timerUpdate: null,
                    },
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                currentTaskTr: state => state.TimeTrackingView.currentTaskTimerecord,
                timerecords: state => state.TaskTimerecordListComp.timerecords,
                themeToDisplay: state =>state.app.themeToDisplay

            }),


        },

        methods: {

            /*
             Envoi la requête d'arrêt du TaskTimerecord en cours
            */
            sendStopQuery() {

                let self = this

                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/users/${self.userSlug}/taskout`, {
                        // ici pas de donnée envoyés, en mode taskin/taskout le backend définit le timeOut
                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        if (response.status == 200) {
                            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                            // vidage du current task timerecord dans le store
                            self.$store.commit('UpdateTimeTrackingViewCurrentTask', null);


                          //on met à jour  la 1ère ligne tu tableau timerecords dans le TaskTimerecordListComp
                            self.timerecords.splice(0, 1, response.data)
                            self.$store.commit('UpdateTaskTimerecordListComp', {
                                'timerecords': self.timerecords
                            });

                            // log
                            self.ga4GlobalEventTrack('Current task stopped' , {bar:'bar'})

                          self.$mixpanel.track("Current task stopped");
                        }
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            let errorCode = '0023'
                            self.showGlobalErrorNotif(self,errorCode )
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error stopping task timerecord', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {
                                "id": errorCode,
                                "detail": "error stopping task timerecord "
                            })
                            self.$sentry.captureMessage(`Error ${errorCode} > error stopping current task timerecord : ${error}`, 'error')

                        }
                    }).then(() => {
                        // toujours exécuté
                        self.isSubmiting = false;
                    })

            },

            /**
             * Créé l'objet timer via easyTimer
             * **/
            initTimer(){
                // require 'easy'
                var { Timer }  = require('easytimer.js');
                var timer = new Timer();

                // on split la duration (avec les ":" comme délimiteur) qui est au format "h:mm:ss"
                let arrayDuration = this.currentTaskTr.duration.split (":");
                // définition des valeurs de départ
                this.timerStartValues.hours = parseInt(arrayDuration[0])
                this.timerStartValues.minutes = parseInt(arrayDuration[1])
                this.timerStartValues.seconds = parseInt(arrayDuration[2])

                // définition de la valeurs affichées de départ (formatés avec h, m , s)
                let value = arrayDuration[0] + 'h ' +arrayDuration[1] +'m ' +arrayDuration[2] +'s' ;
                this.timerDisplayValue = value;
                this.timer = timer;
            },

            /**
             * Préfixe number avec un zéro si number est inférieur à neuf.
             * (4 -> 04)
             * @param number int
             * @returns int
             * @todo mutualiser avec la méthode éponyme du PointeuseComp
             **/
            prefixWithZero(number){

                if(parseInt(number) <= 9){
                    return  '0'+number
                }
                else{
                    return  number
                }

            },


            /**
             * Formate la valeur du timer pour remplacer les ":" par des unités de valeurs 'h','m','s'
             * 12:23:11 -> 12h 23m 11s
             *
             * @todo mutualiser avec la méthode éponyme du PointeuseComp
             **/
            formatTimerDurationDisplay(timer, locale) {

                let val = timer.getTimeValues();
                let h = timer.getTotalTimeValues().hours
                let m = this.prefixWithZero(val.minutes)
                let s = this.prefixWithZero(val.seconds)

                switch (locale) {
                    case  'fr': // 05h 18m 37s
                        return `${h}h ${m}m ${s}s`;

                    case 'en': // 05h 18m 37s
                    default:
                        return `${h}h ${m}m ${s}s`;
                }
            },

            /**
             * Démarre le timer
             * @todo mutualiser avec la méthode éponyme du PointeuseComp
             */
            timerStart(){
                // ajout des valeurs de départ
                this.timer.start({precision: 'seconds', startValues:this.timerStartValues,});
                clearInterval(this.intervals.timerUpdate); // on nettoie l'interval pour éviter une accumulation des déclenchements
                this.intervals.timerUpdate =  setInterval(this.updateTimerDisplay, 1000);
            },

            /**
             * stoppe le timer
             * @todo mutualiser avec la méthode éponyme du PointeuseComp
             */
            timerStop(){
                this.timer.pause()
            },

            /**
             * Met à jour la valeur affichée du timer
             * @todo mutualiser avec la méthode éponyme du PointeuseComp
             */
            updateTimerDisplay(){
                this.timerDisplayValue = this.getTimerValue();
            },

            /**
             * Retourne la valeur du timer
             * @todo mutualiser avec la méthode éponyme du PointeuseComp
             */
            getTimerValue(){
                return this.formatTimerDurationDisplay(this.timer, this.$route.params.locale);
            },

          /**
           * Ouvre la Modal d'édition d'un task timerecord et prépare le timerecord dans le store
           * @param timerecord
           */
          openModalTrEdit: function (timerecord) {
            this.$store.commit('UpdateModalTaskTimerecordsEditionComp', {isVisible: true, timerecord: timerecord, isCurrent: true})

          },

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            // this.logToSentry(this, 'push a log to sentry :)', 'info')


            // On calcule un premier datetime puis on l'actualise chaque seconde
            setInterval(this.calculateDatetimeNow, 1000);

            this.initTimer()
            this.timerStart();

            // listener du stop_current_task
            this.$root.$once('stop_current_task', () => {
                this.sendStopQuery()
            })


          // listener du current_timerecord_edited
          this.$root.$once('current_timerecord_edited', () => {
            this.initTimer() ;this.timerStart();
          })

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    #CurrentTaskComp{
        /*background: #000;*/
        /*padding-bottom: 2rem;*/

      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////
      $height:9rem;
      .fieldBox{
        padding: 2rem ;

        border-radius: 3px;
        background-color: #fff;
        background-image: url("../assets/img/stopwatchBg2.png");
        background-position: center right !important;
        background-repeat: no-repeat !important;
        /*background-size: 412px 214px;*/
        @include touch{
            background-position: center 7rem;
          //background-position: bottom;
          background-size: contain;
            margin: 0.3rem;
          background-position: center bottom !important;

        }

        border-style: solid;
        border-width: 1px;
        border-color: #f4c2c2;


        animation: glow 0.8s infinite alternate;

        @keyframes glow {
          from {
            box-shadow: 0px 0px 12px 0px #f4c2c2;
          }
          to {
            box-shadow: 0px 0px 2px 0px #f4c2c2;
          }
        }

        .currentTask {
          text-align: left;

          .icon {
            font-size: 1rem;
            padding-top: 0.3rem;
          }
          .name {
            font-size: 1.4rem;
            color: $taskColor;
            margin-left: 1.2rem;
            font-weight: bold;
            cursor: pointer;

                .icon {}

              @include touch {
                 margin-left: auto;
              }

            }

            .project{
                margin-left: 1rem;
                font-weight: bold;
                border-left: solid 1px #ccc;
                padding-left: 1rem;
              @include touch {
                display: block;
                border-left: solid 1px transparent !important;
                padding-left: 0; margin-left: auto;
              }
            }

          .tagZone{
            border-left: solid 1px #ccc;
            @include touch {
              display: block;
              border-left: solid 1px transparent !important;
              padding-left: 0; margin-left: auto;
            }
          }

            .client{
                margin-left: 1rem;
                color: $clientColor;
                font-weight: bold;
                border-left: solid 1px #ccc;
                padding-left: 1rem;
              @include touch {
                display: block;
                border-left: solid 1px transparent !important;
                padding-left: 0; margin-left: auto;
              }
            }

          @include mobile {
            text-align: center;
          }
          .isBillable{
            color:$brandPrimary;
            margin-left: 0.5rem;
            border-left: solid 1px #ccc;
            padding-left: 0.5rem;
            @include touch {
              display: block;
              border-left: solid 1px transparent;
              margin-left: auto; padding-left: 0;

            }
                .circle{
                    width: 2rem;
                    height: 2rem;
                    background: #e9f4ce;
                    border-radius: 1.2rem;
                    transition: background-color 200ms ease-in-out;
                    display: inline-block;

                    .icon{
                        color: $brandPrimary;
                        margin: 0.05rem auto 0 0.7rem ;
                        @include touch{
                            margin-left: 0.03rem;
                        }

              }
            }
          }



          .duration{
            /*background: lemonchiffon;*/
            color: $brandThird;
            font-size: 3rem;

            @include mobile {
              font-size: 2rem;
            }
          }

          .stopBtn{
            $size: 3rem;
            width: $size;
            height: $size;
            background: white;
            border: solid 2px $brandRed;
            border-radius: 4rem;
            display: block;
            margin: 1rem auto;

            &:hover{
              box-shadow: 0 0 3px $brandRed;
            }
            &:active{
              box-shadow: inset 0 0 3px $brandRed;
              border-width: 2px;
            }

            .icon{
              height: 1.2rem;
              display: block;
              margin: 0.6rem auto 0;
              color: $brandRed;
            }
          }

        }


      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {

        .fieldBox{
          $bgColor:$darkBg4;
          background-color:$bgColor !important;
          background-image: url("../assets/img/stopwatchBgDark.png") !important;

          border: solid 1px transparent ;

          @keyframes glowDark {
            from {
              box-shadow: 0px 0px 12px 0px $brandPrimary;
            }
            to {
              box-shadow: 0px 0px 2px 0px transparent;
            }
          }
          animation: glowDark 0.8s infinite alternate;


          .name{color:$darkTxt}

          .project{
            border-left: solid 1px lighten($bgColor,11%);
          }

          .tagZone{
            border-left: solid 1px lighten($bgColor,11%);
          }
          .client{
            border-left: solid 1px lighten($bgColor,11%);
            color:#666;
          }
          .isBillable{
            border-left: solid 1px lighten($bgColor,11%);
            color:$brandPrimary;

            .circle {
              background: darken($darkBg,10%);
            }

          }


          .stopBtn {
            background: transparent;
            border: solid 2px $brandPrimary;
            .icon{
              color: $brandPrimary;
            }

          }

          .duration{
            color: $darkContrastTxt
          }

        }

      }
    }


</style>
